<template>
  <span
    class="com-bot-web-link-common-link-text"
    @click.stop="onTextNodeClick"
  >{{ displayName }}</span>
</template>
<script lang="ts" setup>
import { PropType, onBeforeMount } from 'vue';
const props = defineProps({ displayName: { type: String, default: '' }, ext: { type: Object as PropType<Record<string, unknown>>, default: () => null } });


let gid = 0;
let botId = 0;
let url = '';

function onTextNodeClick(): void {
  // BotPageHandle.getInstance().openH5(
  //   gid.toString(),
  //   url,
  //   botId.toString(),
  // );//TODO 引入platform,暂未处理
}

onBeforeMount(() => {
  const { gid: extGid, botId: extBotId, url: extUrl } = props.ext;

  if (gid as number > 0) {
    gid = extGid as number;
  } else {
    gid = 0;
  }
  if (botId as number > 0) {
    botId = extBotId as number;
  } else {
    botId = 0;
  }
  if (url) {
    url = extUrl as string;
  } else {
    url = '';
  }
});
</script>

<style lang="scss">
.com-bot-web-link-common-link-text {
  color: #267be7;
}
</style>
